import React from 'react'
// @ts-ignore
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'

interface Props {
  /** The media name to link to */
  mediaName?: string
}

export const PortfolioTeaser = ({ mediaName }: Props) => {
  const domain = mediaName || parseHostname().publicationName

  return (
    <div className='centered row portfolio'>
      <div className='column'>
        <a href={`https://interaktiv.${domain}.ch`} className='ui fluid image'>
          <img
            src='https://interaktiv.tagesanzeiger.ch/inline-teaser.gif'
            className='portfolio-teaser'
            alt='Die besten Arbeiten des Interaktiv-Teams: Zur Sammlung'
          />
        </a>
      </div>
    </div>
  )
}
